// removed by extract-text-webpack-plugin
module.exports = {"container":"_2RWK_unTFLSqBpDG","selected":"_3y_tR1VqjesnDNl6"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Common/CheckBox/Item.pcss
// module id = 467
// module chunks = 1